import { render, staticRenderFns } from "./Filters.vue?vue&type=template&id=b2ba5a0c&scoped=true&"
import script from "./Filters.vue?vue&type=script&lang=js&"
export * from "./Filters.vue?vue&type=script&lang=js&"
import style0 from "./Filters.vue?vue&type=style&index=0&id=b2ba5a0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2ba5a0c",
  null
  
)

export default component.exports